"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWindowClose = exports.StyledWindowCloseIcon = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const buttonReset_styles_1 = require("../../DesignSystem/styles/buttonReset.styles");
const helpers_1 = require("../../helpers");
const icons_1 = require("../../icons");
exports.StyledWindowCloseIcon = (0, styled_components_1.default)(icons_1.WindowCloseIcon) ``;
exports.StyledWindowClose = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    position: absolute;
    top: ${helpers_1.SIZE_XS};
    right: ${helpers_1.SIZE_XS};
    display: flex;
    width: ${helpers_1.SIZE_L};
    height: ${helpers_1.SIZE_L};

    cursor: pointer;

    background-color: transparent;

    ${({ isInteractable, theme }) => isInteractable &&
    (0, styled_components_1.css) `
            width: ${helpers_1.SIZE_XL};
            height: ${helpers_1.SIZE_XL};

            ${exports.StyledWindowCloseIcon} {
                color: ${theme.colorDialogCloseIcon};
            }

            &:hover {
                background-color: ${theme.colorDialogCloseHighlightLight};
            }

            &:active {
                background-color: ${theme.colorDialogCloseHighlightDark};
            }
        `}

    ${({ isEventsBlocked }) => isEventsBlocked &&
    (0, styled_components_1.css) `
            pointer-events: none;
        `}
`;
//# sourceMappingURL=WindowClose.styles.js.map